import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { RadioTagsState } from '@app/library/states/radio-tags.state';
import {
  TrackMultipleSetTagsFailure,
  TracksTagsSaveRequest,
  TracksTagsSaveSuccess,
} from '@app/library/states/tracks.actions';
import { Dispatch } from '@ngxs-labs/dispatch-decorator';
import { Actions, ofActionDispatched, Select } from '@ngxs/store';
import { UiStoreHelperService } from '@radioking/shared/common-services';
import { SugestionInput } from '@radioking/ui/input';
import amplitude from 'amplitude-js';
import { Observable, Subscription } from 'rxjs';

interface DataInput {
  tracksId: number[];
}

@Component({
  selector: 'rk-add-tag-modal',
  templateUrl: './add-tag-modal.component.html',
  styleUrls: ['./add-tag-modal.component.scss'],
})
export class AddTagModalComponent implements OnInit, OnDestroy {
  isLoading$: Observable<boolean>;

  formTags: UntypedFormGroup;

  @Select(RadioTagsState.tagsFormatted)
  tags$: Observable<SugestionInput[]>;

  subscription = new Subscription();

  constructor(
    public readonly dialogRef: MatDialogRef<AddTagModalComponent>,
    private readonly actions$: Actions,
    private readonly fb: UntypedFormBuilder,
    private readonly uiStore: UiStoreHelperService,
    @Inject(MAT_DIALOG_DATA) public dataIn: DataInput,
  ) {}

  ngOnInit() {
    amplitude.getInstance().logEvent('add tag form');
    this.isLoading$ = this.uiStore.getLoadingState(
      [TracksTagsSaveRequest],
      [TracksTagsSaveSuccess, TrackMultipleSetTagsFailure],
    );

    this.formTags = this.fb.group({
      tags: [[]],
    });

    this.subscription.add(
      this.actions$
        .pipe(ofActionDispatched(TracksTagsSaveSuccess))
        .subscribe(() => this.dialogRef.close()),
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  @Dispatch()
  onSubmit() {
    const eventProperties = {
      tracks_count: this.dataIn.tracksId.length,
    };
    amplitude.getInstance().logEvent('edit_tags_modal', eventProperties);

    return new TracksTagsSaveRequest(
      this.dataIn.tracksId,
      this.formTags.get('tags').value,
    );
  }

  onCancel() {
    this.dialogRef.close(false);
  }
  onAbort() {
    this.dialogRef.close(false);
  }
}
